<template>
    <div class=''>
        <header class="spaceBetween" style="padding:15px;">
            <div class="login-logo spaceLeft">
              <img src="@/assets/images/nylogo.png" alt="" srcset="" height="50" />
            </div>
            <div class="btn-span">
                <span @click="login">登录</span>
                <span @click="register">注册</span>
            </div>
        </header>
        <pswd-modify :noInit="true"></pswd-modify>
    </div>
</template>

<script>
import pswdModify from "@/pages/security/main/pswd-modify"
export default {
    components: {pswdModify},
    data() {
        return {

        };
    },
    computed: {},
    methods: {
        login(){
            this.$router.push("/login");
        },
        register(){
            this.$router.push("/login/register")
        },
        online(){
            location.href="http://www.trustslink.com/";
        }
    },
    created() {},
    mounted() {}
}
</script>
<style scoped lang="less">
.btn-span span{
    margin:0 5px;
    cursor: pointer;
}
.login-logo {
  width: 80%;
  margin:0 auto;
  .logo-text{
    height: 55px;
    display: inline-block;
    margin-left:12%;
  }
  .logo-right{
    border-left:1px solid #d1dff0;
    margin-left:12px;
    padding-left:12px;
    color:#065abc;
    font-size: 16px;
    font-weight: bold;
    .logo-right-sm{
      font-size: 12px;
      font-weight: lighter;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components-frame/forget-passwd.vue